import React, { useEffect, useState } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import { addProjectDetails } from "../../redux/actions/uiActions";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },

  addTeamBtn: {
    height: "2.6rem",
    width: "9rem",
  },

  teamMemberDisplay: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem",
  },
  teamName: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    marginRight: "1rem",
  },

  teamLink: { fontWeight: "500", fontSize: "1.4rem", lineHeight: "2.4rem" },
}));

const ProjectRegistrationStepTwo = ({
  onNextClick,
  changeFlag,
  setDisableButton,
}) => {
  const classes = useStyles();

  const [devProgress, setDevProgress] = useState("");
  const [incubators, setIncubators] = useState("");
  const [marketingBudget, setMarketingBudget] = useState(0);

  const [teamMemberName, setTeamMemberName] = useState("");
  const [teamMemberLink, setTeamMemberLink] = useState("");

  const [teamMembers, setTeamMembers] = useState([{}]);

  const projectData = useSelector((state) => state.ui.projectData);

  const dispatch = useDispatch();
  useEffect(() => {
    if (devProgress && incubators && marketingBudget) setDisableButton(false);
  }, [devProgress, incubators, marketingBudget]);
  useEffect(() => {
    if (Object.keys(projectData).length > 0) {
      setDevProgress(projectData.devProgress || "");
      setIncubators(projectData.incubators || "");
      setMarketingBudget(projectData.marketingBudget || "");
      setTeamMembers(projectData.teamMembers || [{}]);
    }
  }, [projectData]);

  useEffect(() => {
    if (changeFlag === 2) {
      console.log("flag clicked 2");
      dispatch(
        addProjectDetails({
          devProgress,
          incubators,
          marketingBudget,
          // budgetLeft: marketingBudget,
          teamMembers,
        })
      );

      onNextClick();
    }
  }, [changeFlag]);

  const getTeamMembersList = () => {
    return teamMembers.map((tm) => (
      <Box className={classes.teamMemberDisplay}>
        <Typography className={classes.teamName}>
          {tm.teamMemberName}
        </Typography>
        <Typography className={classes.teamLink}>
          {tm.teamMemberLink}
        </Typography>
      </Box>
    ));
  };

  const onAddTeamMember = () => {
    if (teamMemberName && teamMemberLink) {
      setTeamMembers((tms) => [...tms, { teamMemberName, teamMemberLink }]);
      setTeamMemberName("");
      setTeamMemberLink("");
    }
  };
  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 2</Typography>

        <Typography className={classes.headingDesc}>
          Provide fund details for your project
        </Typography>
      </Box>

      <Box>
        <InputWithLabel
          label="Development Progress (out of 100%)"
          placeholder="i.e: 35"
          width={100}
          value={devProgress}
          setValue={setDevProgress}
          maxValue1={100}
          rightText="%"
          type="number"
        />
        <InputWithLabel
          label="Incubator & Investor Names"
          placeholder="Enter incubator/ investors names"
          value={incubators}
          setValue={setIncubators}
        />
        <InputWithLabel
          label="Marketing Budget"
          placeholder="Enter your total marketing budget"
          value={marketingBudget}
          setValue={setMarketingBudget}
          type="number"
        />
        <Box>
          <InputWithLabel
            label="Team Member(s)"
            placeholder="John Doe"
            placeholder2="www.linkedin.com/johndoe"
            width={110}
            value={teamMemberName}
            setValue={setTeamMemberName}
            value2={teamMemberLink}
            setValue2={setTeamMemberLink}
            Button={() => (
              <Button className={classes.addTeamBtn} onClick={onAddTeamMember}>
                <Typography>Add</Typography>
              </Button>
            )}
            Entered={() => getTeamMembersList()}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectRegistrationStepTwo;
